export default "__VITE_PUBLIC_ASSET__7b3dc3c7__"